// Demo snippets for testing
export const demoSnippets = [
  {
    tag: '/py1',
    title: 'Python Hello World',
    content: 'print("Hello, TypeSync!")\nprint("This is a demo snippet")',
    language: 'python',
    typingSpeed: 80
  },
  {
    tag: '/js1',
    title: 'JavaScript Function',
    content: 'const greet = (name) => {\n  console.log(`Hello, ${name}!`);\n  return `Welcome to TypeSync, ${name}!`;\n};\n\ngreet("Developer");',
    language: 'javascript',
    typingSpeed: 60
  },
  {
    tag: '/note',
    title: 'Quick Note',
    content: 'This is a quick note for testing.\n\n- Remember to test the search functionality\n- Try editing this snippet\n- Test the offline mode',
    language: 'text',
    typingSpeed: 100
  },
  {
    tag: '/css1',
    title: 'CSS Flexbox',
    content: '.container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}',
    language: 'css',
    typingSpeed: 70
  },
  {
    tag: '/html1',
    title: 'HTML Template',
    content: '<!DOCTYPE html>\n<html lang="en">\n<head>\n  <meta charset="UTF-8">\n  <meta name="viewport" content="width=device-width, initial-scale=1.0">\n  <title>TypeSync Demo</title>\n</head>\n<body>\n  <h1>Hello TypeSync!</h1>\n  <p>This is a demo HTML snippet.</p>\n</body>\n</html>',
    language: 'html',
    typingSpeed: 90
  }
];

export const addDemoSnippets = async (addSnippetFunction) => {
  const promises = demoSnippets.map(snippet => addSnippetFunction(snippet));
  try {
    await Promise.all(promises);
    return true;
  } catch (error) {
    console.error('Error adding demo snippets:', error);
    return false;
  }
};
